module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/childcare-desktop-6cf2526ff1db306a4a067f68acc3319a.jpg";